<template>
  <section>
    <div class="titulo">
      <div class="margem container">
        <div class="linha alinha-v">
          <div class="m-icone esquerda">
            <a style="cursor: pointer" class="icone-voltar m-d" @click="voltar"></a>
          </div>
          <h2>Registros do dia — Check-in/Check-out</h2>
        </div>
      </div>
    </div>
    <div class="margem container checkin-dia-toolbar">
      <div class="checkin-dia-data-linha linha alinha-v">
        <label class="checkin-dia-data-label" for="checkin-dia-data">Data</label>
        <input id="checkin-dia-data" v-model="dataSelecionada" type="date" class="checkin-dia-data-input" />
        <button type="button" class="checkin-dia-btn-hoje" @click="irHoje">Hoje</button>
        <router-link :to="{ path: '/' }" class="checkin-dia-link-cal">Ir para o calendário</router-link>
      </div>
    </div>
    <div class="margem container">
      <AgendaListaVisitasDia :data-selecionada="dataSelecionada" origem-dados-completos="checkin-dia" />
    </div>
  </section>
</template>
<script>
import AgendaListaVisitasDia from "./AgendaListaVisitasDia.vue";

function ymdDeDate(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export default {
  name: "ListaCheckinDiaView",

  components: { AgendaListaVisitasDia },

  data() {
    return {
      dataSelecionada: ymdDeDate(new Date()),
    };
  },

  watch: {
    "$route.query.data"(val) {
      const s = val && /^\d{4}-\d{2}-\d{2}$/.test(String(val)) ? String(val).slice(0, 10) : null;
      if (s && s !== this.dataSelecionada) {
        this.dataSelecionada = s;
      }
    },
    dataSelecionada(val) {
      if (this.$route.query.data === val) return;
      this.$router.replace({ path: "/acesso/checkin-dia", query: { data: val } });
    },
  },

  created() {
    const raw = this.$route.query.data;
    if (raw && /^\d{4}-\d{2}-\d{2}$/.test(String(raw))) {
      this.dataSelecionada = String(raw).slice(0, 10);
      return;
    }
    this.$router.replace({ path: "/acesso/checkin-dia", query: { data: this.dataSelecionada } });
  },

  methods: {
    voltar() {
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.push({ path: "/" });
      }
    },
    irHoje() {
      this.dataSelecionada = ymdDeDate(new Date());
    },
  },
};
</script>
<style scoped>
.checkin-dia-toolbar {
  margin-bottom: 0.75rem;
}

.checkin-dia-data-linha {
  flex-wrap: wrap;
  gap: 0.65rem 1rem;
  align-items: center;
}

.checkin-dia-data-label {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--cor-fonte-fraca);
}

.checkin-dia-data-input {
  padding: 0.45rem 0.55rem;
  border: 1px solid var(--cor-separador);
  border-radius: 8px;
  font-size: 0.9rem;
  background: var(--cor-bg);
  color: var(--cor-fonte);
}

.checkin-dia-btn-hoje {
  padding: 0.45rem 0.85rem;
  font-size: 0.82rem;
  font-weight: 600;
  border: 1px solid var(--cor-separador);
  border-radius: 8px;
  background: var(--cor-bg);
  cursor: pointer;
  color: var(--cor-primaria-forte);
}

.checkin-dia-btn-hoje:hover {
  border-color: var(--cor-primaria-media);
}

.checkin-dia-link-cal {
  margin-left: auto;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--cor-primaria-forte);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.checkin-dia-link-cal:hover {
  color: var(--cor-primaria);
}
</style>
